// Create a new component Ticker.jsx:
import React from 'react';
import './Ticker.scss';

const Ticker = () => {
  const tickerItems = [
    { icon: 'fa-bolt', text: '24/7 AI Receptionist Never Sleeps' },
    { icon: 'fa-chart-line', text: '10X Your Booking Conversion Rate' },
    { icon: 'fa-clock', text: 'Zero Missed Calls, Zero Lost Revenue' },
    { icon: 'fa-sync-alt', text: 'Automated SMS Confirmations & Reminders' },
    { icon: 'fa-robot', text: 'AI-Powered Lead Qualification & Booking' },
    { icon: 'fa-trophy', text: 'Become #1 In Your Market' },
    { icon: 'fa-users', text: 'Handle 3x More Clients Without Hiring' },
    { icon: 'fa-shield-alt', text: 'Enterprise-Grade Security & Reliability' }
  ];

  return (
    <div className="ticker-wrapper">
      <div className="ticker-container">
        <div className="ticker-track">
          {tickerItems.map((item, index) => (
            <div key={index} className="ticker-item">
              <i className={`fas ${item.icon}`}></i>
              <span>{item.text}</span>
            </div>
          ))}
          {/* Duplicate for seamless loop */}
          {tickerItems.map((item, index) => (
            <div key={`dup-${index}`} className="ticker-item">
              <i className={`fas ${item.icon}`}></i>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ticker;